import enTexts from './locales/en.json'
import esTexts from './locales/es.json'

const resources = {
  en: { translation: enTexts },
  es: { translation: esTexts }
  // otros idiomas...
}

type possibleLanguages = 'es' | 'en'
const currentLanguage: possibleLanguages = 'es' // Esto se puede configurar para cambiar el idioma

type selectedLanguage = keyof typeof esTexts

export function t(key: selectedLanguage) {
  return resources[currentLanguage].translation[key] || key
}
